import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { catchError, map } from 'rxjs/operators';
import { AccessSolicitudViewModel } from '../solicitudes/types/enum';
import { BASE_URL_SERVICE } from 'src/app/app.module';
import { of } from 'rxjs';
import { ExceptionManager } from '../../core/_infrastructure/classes/handlers/exceptionManager';

export function AccessSolicitudImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            const exceptionManager = inject(ExceptionManager);

            let params = new HttpParams();

            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', id);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessSolicitud/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
                catchError(error => {
                    exceptionManager.handleError400(error);
                    return of(false);
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessSolicitanteImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            const exceptionManager = inject(ExceptionManager);
            let params = new HttpParams();

            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', route.parent!.paramMap.get('id')!);
            params = params.append('idSolicitante', id);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessSolicitante/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
                catchError(error => {
                    exceptionManager.handleError400(error);
                    return of(false);
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessProductoImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idProd = route.paramMap.get('idprod');

        if (idProd) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();

            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', route.parent!.paramMap.get('id')!);
            params = params.append('idProducto', idProd);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessProducto/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessEmbalajeImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idEmb = route.paramMap.get('idemb');

        if (idEmb) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();

            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', route.parent!.paramMap.get('id')!);
            params = params.append('idEmbalaje', idEmb);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessEmbalaje/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessDocumentosImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idDocumento = route.paramMap.get('idDocumento');

        if (idDocumento) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();

            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', route.parent!.paramMap.get('id')!);
            params = params.append('idDocumento', idDocumento);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessDocumento/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessRechazoParcialImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();

            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', id);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessRechazoParcial/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessSeguimientoImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idSeguimiento = route.paramMap.get('idSeguimiento');

        if (idSeguimiento) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);

            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitud', route.parent!.paramMap.get('id')!);
            params = params.append('idSeguimiento', idSeguimiento);

            return http.get<boolean>(baseUrl + 'api/importacion/main/accessSeguimiento/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function ActionEstadoImporGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        let idSolicitud = route.paramMap.get('id');

        if (!idSolicitud) {
            console.error('You are not allowed to see this page');
            return false;
            //route.parent!.paramMap.get('idSolicitud')!;
        }

        const http = inject(HttpClient);
        const baseUrl = inject(BASE_URL_SERVICE);
        const router = inject(Router);
        const authService = inject(AuthService);
        const exceptionManager = inject(ExceptionManager);

        let user = authService.getLoggedInUser()!;
        let params = new HttpParams();
        params = params.append('idSolicitud', idSolicitud!);

        return http.get<AccessSolicitudViewModel>(baseUrl + 'api/importacion/main/idEstadoTipoSubtipoSolicitud/', { params: params }).pipe(
            map(res => {
                if (user.getAction(route.data.actionCode, res.IdEstadoSolicitud, res.IdTipoSolicitud, res.IdSubTipoSolicitud!).Visible) {
                    return true;
                } else {
                    console.error('You are not allowed to see this page');
                    router.navigate(['/']);
                    return false;
                }
            }),
            catchError(error => {
                exceptionManager.handleError400(error);
                return of(false);
            }),
        );
    };
}
